<template>
    <div id="login_comp">
        <div id="page-content-wrapper" class="admin-content-area">
          <div class="page-name">{{name}}</div>
            <div class="container-fluid">
                 <div class="admin-page-content change-password">
                    <div :class="`loader${loaderClass}`" v-show="loading"></div>
                    <section class="internal-container border-top-table-fl">
                        <form class="" id="resetForm">
                          <div class="form-row">
                            <div class="col-md-3 form-group">
                                <label class="control-label" for="login_oldpass">Enter Old Password :</label>
                                <input class="form-control" v-model="oldPassword" id="login_oldpass"
                                    name="login_oldpass" type="password">
                                <div class="field-error">{{oldpassError}}</div>
                            </div>
                          </div>
                          <div class="form-row">
                            <div class="col-md-3 form-group">
                                <label class="control-label" for="login_pass">Enter New Password :</label>
                                <input class="form-control" v-model="newPassword" id="login_pass"
                                    name="login_pass" type="password">
                                <div class="field-error">{{passError}}</div>
                                <div class="field-error">{{differror_msg}}</div>
                            </div>
                          </div>
                          <div class="form-row">
                            <div class="col-md-3 form-group">
                                <label class="control-label" for="login_password">Confirm New Password :</label>
                                <input class="form-control" v-model="confirmPassword" id="login_password"
                                    name="login_password" type="password">
                                <div class="field-error">{{confirmpassError}}</div>
                            </div>
                          </div>
                          <div class="field-error">{{error}}</div>
                          <div class="btn-groups">
                              <a class="btn btn-primary" href="javascript:void(0)" v-on:click="changePassword(this)"> <i class="fp-submit"> </i> Change</a>
                              <router-link class="btn btn-tertiary" href="javascript:void(0)" v-bind:to="{path:'/profile'}"> <i class="fp-close"> </i> Cancel</router-link>
                          </div>
                        </form>
                    </section>
                 </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';

export default {
  name: "change_password",
  mixins:[commonMixins],
  data: () => ({
    confirmError:'',
    name:"Change Password",
    userPinError:"",
    userPin:"",
    getPin:"",
    confirmUserPin:"",
    email: "",
    newPassword: "",
    oldPassword: "",
    error_msg: "",
    error: "",
    userRole: "",
    passError: "",
    loading: false,
    loggedinUserId: "",
    oldpassError: "",
    adminCan: "",
    nameerror: "",
    differror_msg: "",
    confirmPassword:"",
    confirmpassError:""
  }),
  mounted: function() {
    var self = this;
    this.email = this.$route.query.email;
    var userObj = localStorage.getItem("user_obj");
    var role = null;

    //if user logged in than remove login button and registration button
    if (userObj && userObj != null) {
      var userJson = JSON.parse(userObj);
      if (userJson.roles.length > 0) {
        role = userJson.roles[0].name;
        this.userRole = userJson.roles[0].name;

        this.loggedinUserId = userJson.id;
      }

    //   EventBus.$emit("logged-in", false, userJson["contact"], role);
    }

    this.getPermissions();
  },
  methods: {
    changePassword: function() {
      var self = this;

      self.error_msg = "";
      self.error = "";
      self.passError = "";
      self.differror_msg = "";
      self.oldpassError = "";
      self.confirmpassError = "";

      if (!self.newPassword) {
        self.passError = "";
        self.passError = "Password Required";
      }
      if (!self.oldPassword) {
        self.oldpassError = "";
        self.oldpassError = "Old Password Required";
      }

      if (self.newPassword && self.newPassword.length < 6) {
        self.passError = "";
        self.passError = "Password Must be More than 6 character";
      }
      if (self.oldPassword && self.oldPassword.length < 6) {
        self.oldpassError = "";
        self.oldpassError = "Password Must be More than 6 character";
      }
      if (self.newPassword && self.newPassword != self.confirmPassword) {
        self.confirmpassError = "";
        self.confirmpassError = "Password Not Matching";
      }
      if (!self.confirmPassword) {
        self.confirmpassError = "";
        self.confirmpassError = "Confirm Password Required";
      }

      if (self.confirmPassword && self.confirmPassword.length < 6) {
        self.confirmpassError = "Password Must be More than 6 character";
      }

      if (
        self.newPassword.length > 5 &&
        self.newPassword &&
        self.oldPassword == self.newPassword
      ) {
        self.differror_msg = "";
        self.differror_msg = "Password Must Be Different From Old Password";
        self.passError = "";
      }

      if (
        self.passError == "" &&
        self.differror_msg == "" &&
        self.oldpassError == "" &&
        self.confirmpassError == ""
      ) {
        self.loading = true;

        $.ajax({
          url: process.env.ROOT_API + "/user/change_password",
          type: "POST",
          crossDomain: true,
          headers: this.ajxHeaders,
          data: {
            email: atob(self.email),
            oldPassword: self.oldPassword,
            password: self.newPassword,
            confirmPassword: self.confirmPassword
          },
          dataType: "json",
          success: function(data) {
            self.loading = false;
            if (data.status == "success") {
              self.confirmPassword = "";
              self.newPassword = "";
              self.oldPassword = "";

              self.$swal("", "Password Changed Successfully", "success");
              self.$router.push("/profile");
            }
            if (data.code == 201) {
              self.error = data.message;
            }
          },
          error: function(jqXHR, exception) {
            self.loading = false;
            console.log(jqXHR.responseJSON);
            if (jqXHR.status == 0) {
              self.error = "Remote server cannot be reached";
            } else {
              self.error = jqXHR.responseJSON;
              self.replybtn = "Send";
            }
          }
        });
      }
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue